import React from 'react';

const PrivacyPolicyPage: React.FC = () => {

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Política de Privacidad</h1>
          <p className="text-lg text-gray-600">Su privacidad es muy importante para nosotros</p>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
          <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
            <p className="font-bold text-lg text-blue-800 mb-2">POLÍTICA DE PRIVACIDAD</p>
            <p className="mb-4">
              Su privacidad es muy importante para nosotros. Nuestra política es respetar y proteger la privacidad de los visitantes a nuestra página web.
              El propósito de esta Política de Privacidad es proveerle una descripción del tipo de información que recopilamos y cómo la utilizamos.
            </p>
          </div>

          <section>
            <p className="mb-4">
              Realtypy no recopila datos que identifican individualmente a nuestros usuarios sin que estos elijan la opción de darnos esos datos vía email
              o a través del sistema automático de búsqueda de propiedades. Incluso cuando elige darnos esa opción, la mantenemos de forma confidencial,
              y no facilitamos su email a terceros.
            </p>
          </section>

          <section>
            <p className="mb-4">
              Cuando recibimos visitantes en realtypy.com recogemos alguna información básica que no identifica a los usuarios. Esto incluye el tráfico
              de visitas a la web, qué páginas son visitadas y durante cuánto tiempo, de dónde vienen esas visitas y qué ISP está utilizando. Utilizamos
              esa información para mejorar la calidad del sitio, o ajustar más la información que ofrecemos, y hacer que su visita a nuestra web sea
              lo más valiosa y eficaz posible.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
              <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">1</span>
              ENLACES A OTRAS WEBS
            </h2>
            <p className="mb-4">
              Por favor, tenga en cuenta que cuando pulsa en un enlace que le lleva a otro sitio, usted queda sujeto a las políticas de privacidad
              de esos sitios web. Realtypy apoya la protección de la privacidad en Internet, pero no se hace responsable de los sitios web de terceros.
              Le animamos a leer las políticas de privacidad de todos los sitios web a los que acceda.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
              <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">2</span>
              CONSENTIMIENTO PARA RECOGER INFORMACIÓN NO IDENTIFICABLE
            </h2>
            <p className="mb-4">
              Al utilizar nuestro sitio web, está permitiendo a Realtypy recopilar y usar la información descrita en esta directiva. Si Realtypy
              actualiza esta directiva de privacidad, tales cambios serán anunciados en esta página. Para que usted sea siempre consciente de la
              información que recogemos y cómo la usamos, le recomendamos que visite regularmente esta página.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center text-gray-500 text-sm">
          <p>Última actualización: {new Date().toLocaleDateString('es-ES')}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;